import { lazy, Suspense } from 'react'
import { useQuery } from '@tanstack/react-query'
import { profileQuery, useUserPermissions } from 'entities/currentUser'
import { useLanguage } from 'entities/language'
import { isEmpty } from 'shared/lib'
import { strings } from 'shared/translations'
import { Spinner } from 'shared/ui'
import { AuthPage, useToken } from '../auth'
import { UserFailed } from './FailedUser'

const LazyApp = lazy(() => import('./Providers'))

export function Root() {
  const { token, setToken, removeToken } = useToken()
  const { language } = useLanguage()

  strings.setLanguage(language)

  const { data: userData, isError: isUserDataError } = useQuery({
    ...profileQuery,
    enabled: Boolean(token),
    refetchOnWindowFocus: true,
  })

  const { data: userPermission, isError: isUserPermissionsError } =
    useUserPermissions(undefined, {
      enabled: Boolean(token),
      refetchOnWindowFocus: true,
    })

  if (!token) {
    return <AuthPage setToken={setToken} />
  }
  if (isUserDataError || isUserPermissionsError) {
    removeToken()
  }

  if (!userData || !userPermission) {
    return <Spinner />
  }

  if (isEmpty(userData)) {
    return <UserFailed />
  }

  return (
    <Suspense fallback={<Spinner />}>
      <LazyApp />
    </Suspense>
  )
}
